import {
  getCosToken,
  putObjectWithCosToken,
  type PutObjectWithCosTokenResult,
} from "./cos-token";

/** 数字人头像素材（图片/视频）上传结果 */
export type CosUploadAvatarFileResult = PutObjectWithCosTokenResult;

export interface CosUploadAvatarFileOptions {
  onProgress?: (progress: number) => void;
}

/**
 * 数字人场景：使用临时密钥将图片或视频直传 COS（actor 场景）
 */
export const cosUploadAvatarFile = async (
  file: File,
  options?: CosUploadAvatarFileOptions
): Promise<CosUploadAvatarFileResult> => {
  const token = await getCosToken({ scene: "actor" });
  return putObjectWithCosToken(token, {
    file,
    onProgress: options?.onProgress,
  });
};
